import { render, staticRenderFns } from "./TicketStatusList.vue?vue&type=template&id=03d182e1&scoped=true&"
import script from "./TicketStatusList.vue?vue&type=script&lang=js&"
export * from "./TicketStatusList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d182e1",
  null
  
)

export default component.exports